export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getHomePageContent() {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/setting/home_page")
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        // Pictures, list and JSON settings are sent separately; `settings` only
        // contributes its translated texts.
        updateHomePage(_, {settings, pictures, removedPictures, featuredIds, features, sections}) {
            const nonTextSettings = [
                'home_page_picture_1', 'home_page_picture_2', 'home_page_picture_3',
                'home_page_featured_product', 'home_page_features', 'home_page_sections',
            ]
            let formData = new FormData();
            Object.values(settings).forEach(setting => {
                if (!nonTextSettings.includes(setting.name)) {
                    formData.append(setting.name + '[en_value]', setting.en_value ?? '')
                    formData.append(setting.name + '[fa_value]', setting.fa_value ?? '')
                }
            });
            Object.entries(pictures).forEach(([name, file]) => formData.append(name, file))
            removedPictures.forEach(name => formData.append('home_page_remove_pictures[]', name))
            // JSON strings: form data has no way to send an empty list.
            formData.append('home_page_featured_product', JSON.stringify(featuredIds))
            formData.append('home_page_features', JSON.stringify(features))
            formData.append('home_page_sections', JSON.stringify(sections))
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/setting/home_page", formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateDollarPrice(_, data) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/setting/dollor_price", {
                    price: data
                })
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    },
}

